import React, { useEffect, useRef, useState } from "react";
import { Box, Typography, IconButton, Slider } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";

const AudioPlayer = ({ file, onDelete }) => {
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const audioRef = useRef(null);

    useEffect(() => {
        const audio = new Audio(URL.createObjectURL(file));
        audio.addEventListener("loadedmetadata", () => {
            setDuration(audio.duration);
        });
        audioRef.current = audio;

        return () => {
            audio.pause();
            URL.revokeObjectURL(audio.src);
        };
    }, [file]);

    const togglePlay = () => {
        if (audioRef.current) {
            if (isPlaying) {
                audioRef.current.pause();
            } else {
                audioRef.current.play().catch((error) => console.error(error));
            }
            setIsPlaying(!isPlaying);
        }
    };

    const handleTimeUpdate = () => {
        setCurrentTime(audioRef.current.currentTime);
    };

    const handleSliderChange = (_, newValue) => {
        if (audioRef.current) {
            audioRef.current.currentTime = newValue;
            setCurrentTime(newValue);
        }
    };

    useEffect(() => {
        const audio = audioRef.current;
        audio.addEventListener("timeupdate", handleTimeUpdate);
        audio.addEventListener("ended", () => setIsPlaying(false));

        return () => {
            audio.removeEventListener("timeupdate", handleTimeUpdate);
            audio.removeEventListener("ended", () => setIsPlaying(false));
        };
    }, []);

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                bgcolor: "#F8F8F8",
                borderRadius: "8px",
                p: 2,
            }}
        >
            <Box sx={{ display: "flex", alignItems: "center" }}>
                <IconButton onClick={togglePlay} sx={{ color: "#16BB4D" }}>
                    {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
                </IconButton>
                <Typography variant="body2" sx={{ flexGrow: 1, ml: 1 }}>
                    {file.name}
                </Typography>
                <IconButton
                    onClick={() => onDelete(file)}
                    sx={{ color: "#FF4D4D" }}
                >
                    <DeleteOutlineRoundedIcon />
                </IconButton>
            </Box>
            <Slider
                value={currentTime}
                max={duration}
                onChange={handleSliderChange}
            />
            <Typography variant="caption" sx={{ alignSelf: "flex-end" }}>
                {Math.floor(currentTime / 60)}:
                {Math.floor(currentTime % 60)
                    .toString()
                    .padStart(2, "0")}{" "}
                /{Math.floor(duration / 60)}:
                {Math.floor(duration % 60)
                    .toString()
                    .padStart(2, "0")}
            </Typography>
        </Box>
    );
};

export default AudioPlayer;
